import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/lib/lang";

export default function AdminLogin() {
  const { lang } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/tableau-de-bord");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-steel transition-colors hover:text-electric">
          <ArrowLeft size={15} /> {lang === "fr" ? "Retour au site" : "Back to site"}
        </Link>
        <form onSubmit={onSubmit} className="rounded-2xl border border-slate-200/90 bg-white p-9 shadow-card" data-testid="admin-login-form">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-badge text-sky-700">
            <Lock size={22} />
          </span>
          <h1 className="mt-5 font-display text-2xl font-bold text-navy-950">
            {lang === "fr" ? "Espace administratif" : "Admin area"}
          </h1>
          <p className="mt-2 text-sm text-graphite">
            {lang === "fr" ? "Accès réservé — demandes et publications." : "Restricted access — leads and publications."}
          </p>
          <div className="mt-7 space-y-4">
            <div>
              <label htmlFor="a-email" className="mb-1.5 block text-[13px] font-bold text-navy-900">Email</label>
              <input id="a-email" type="email" required data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-navy-950 outline-none focus:border-electric" />
            </div>
            <div>
              <label htmlFor="a-pass" className="mb-1.5 block text-[13px] font-bold text-navy-900">
                {lang === "fr" ? "Mot de passe" : "Password"}
              </label>
              <input id="a-pass" type="password" required data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-navy-950 outline-none focus:border-electric" />
            </div>
          </div>
          {error && <p role="alert" className="mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="mt-6 w-full rounded-full bg-electric py-3.5 text-sm font-bold text-white transition-colors hover:bg-electric-dark disabled:opacity-60">
            {loading ? "…" : lang === "fr" ? "Se connecter" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
